import React from 'react';

const WatermarkedImage = ({ src, alt, watermark = '© T1Productionz', style = {} }) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: 'auto',
          maxHeight: '70vh',
          objectFit: 'contain',
          display: 'block',
          pointerEvents: 'none',
          userSelect: 'none',
          WebkitUserDrag: 'none',
          ...style           
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
          pointerEvents: 'none',
          userSelect: 'none',
          zIndex: 10,
        }}
      >
        {watermark}
      </div>
    </div>
  );
};

export default WatermarkedImage;